module.exports = __webpack_public_path__ + "afda3c7469c4907869eeb77c03d98a93.svg";